/*
 * Free-Products im Cart-Drawer.
 * Reagiert auf co2.cart.initialized (feuert verlässlich nach allen Cart-DOM-Updates).
 * Auto-Remove invalider Gifts via Dawn's <cart-remove-button>.
 */
(function () {
  /* Trailing-edge: während ein Cycle läuft, kommende Events nur als pending markieren. */
  var isHandling = false;
  var pending = false;

  /* ─── Helpers ───────────────────────────────────────────────── */

  function getRoot() {
    return document.querySelector('[data-free-products-root]');
  }

  /* Alle State-Klassen zentral — hide/show räumen sie gemeinsam ab, damit sich
     Progress-, Reached- und Soldout-Hintergrund nie überlagern. */
  var STATE_CLASSES = [
    'cart-drawer__free-products--progress',
    'cart-drawer__free-products--reached',
    'cart-drawer__free-products--soldout',
  ];

  function hideFreeProductArea() {
    var root = getRoot();
    if (!root) return;
    root.hidden = true;
    root.innerHTML = '';
    root.classList.remove(...STATE_CLASSES);
  }

  function showFreeProductArea(html, stateClass) {
    var root = getRoot();
    if (!root) return;
    root.innerHTML = html;
    root.classList.remove(...STATE_CLASSES);
    root.classList.add(stateClass);
    root.hidden = false;
  }

  function findProduct(products, handle) {
    return products.find(function (p) { return p.handle === handle; });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function pickText(root, singularKey, pluralKey, usePlural) {
    return usePlural ? root.dataset[pluralKey] : root.dataset[singularKey];
  }

  function withAmount(template, amount) {
    // Template escapen, Money-HTML (transcy-money) als Marker-Platzhalter durchschleusen
    var PLACEHOLDER = '___AMOUNT_PLACEHOLDER___';
    var escaped = escapeHtml(String(template).replace(/\{\{\s*amount\s*\}\}/g, PLACEHOLDER));
    return escaped.split(PLACEHOLDER).join(formatPrice(amount));
  }

  // Platzhalter füllen, noch ohne Escaping — Plaintext dient Karten UND Live-Region.
  // Replacer als Funktion, damit $-Sequenzen in Titeln nicht als Muster gelesen werden.
  function withProducts(template, names) {
    var joined = names.join(', ');
    return String(template).replace(/\{\{\s*products\s*\}\}/g, function () {
      return joined;
    });
  }

  function filterRenderableGroups(groups) {
    if (!groups) return [];
    return groups.filter(function (g) {
      return g && g.addAutomatically !== true && g.productItems && g.productItems.length > 0;
    });
  }

  /* soldoutFreeProducts() liefert nur erreichte, wegen Ausverkauf nicht einlösbare Gruppen als
     { threshold, products }. Kein addAutomatically-Filter: gilt für automatische wie wählbare Gifts.
     typeof-Guard, solange die Lib-Methode noch nicht überall deployed ist. */
  async function getSoldoutGroups() {
    if (typeof co2.soldoutFreeProducts !== 'function') return [];
    var groups;
    try {
      groups = await co2.soldoutFreeProducts();
    } catch (error) {
      /* Nur die Meldung ausfallen lassen — ein Throw würde sonst Vorschau/Auswahl mitnehmen */
      console.error('soldoutFreeProducts failed', error);
      return [];
    }
    if (!groups) return [];
    return groups.filter(function (g) {
      return g && g.products && g.products.length > 0;
    });
  }

  /* ─── Render ────────────────────────────────────────────────── */

  function renderProductPreview(product) {
    if (!product) return '';
    return (
      '<div class="cart-drawer__free-products__preview">' +
        '<div class="cart-drawer__free-products__image">' +
          '<img src="' + escapeHtml(product.image || '') + '"' +
          ' alt="' + escapeHtml(product.title || '') + '" width="52" height="52" loading="lazy">' +
        '</div>' +
        '<div class="cart-drawer__free-products__title">' + escapeHtml(product.title || '') + '</div>' +
      '</div>'
    );
  }

  /* Meldungstext je Gruppe als Plaintext; Plural ab zwei benannten Produkten.
     Gemeinsame Quelle für die sichtbaren Karten und die Live-Region. */
  function soldoutMessageTexts(groups) {
    var root = getRoot();
    if (!root) return [];

    return groups
      .map(function (group) {
        var names = group.products
          .map(function (p) {
            /* handle als Fallback: sonst verschwindet die Meldung bei fehlendem Titel */
            return p.title || p.handle || '';
          })
          .filter(Boolean);
        if (names.length === 0) return '';

        var template = pickText(root, 'textSoldoutSingular', 'textSoldoutPlural', names.length > 1);
        if (!template) return '';

        return withProducts(template, names);
      })
      .filter(Boolean);
  }

  /* Pro betroffener Gruppe eine Karte — ohne role="status": die Karten werden samt Text
     eingefügt, angesagt wird über die persistente Live-Region in announceSoldout(). */
  function renderSoldoutMessages(groups) {
    return soldoutMessageTexts(groups)
      .map(function (text) {
        return '<div class="cart-drawer__free-products__soldout">' + escapeHtml(text) + '</div>';
      })
      .join('');
  }

  /* Live-Region liegt außerhalb von #CartDrawer und überlebt den Rerender.
     Nur bei echter Textänderung schreiben — sonst sagt jeder der beiden Cart-Trigger erneut an. */
  function announceSoldout(groups) {
    var region = document.querySelector('[data-free-products-live]');
    if (!region) return;
    var text = soldoutMessageTexts(groups).join(' ');
    if (region.textContent === text) return;
    region.textContent = text;
  }

  /* nextFreeProducts() liefert { threshold, sub_total, items: [groups] } */
  function renderProgressState(nextObj, products, extraHtml) {
    var root = getRoot();
    if (!root) return;

    /* Leer-Fall entscheidet der Aufrufer (sonst würde eine Soldout-Meldung mitgewipt) */
    var groups = filterRenderableGroups(nextObj && nextObj.items);
    if (groups.length === 0) return;

    var usePlural = groups.length > 1 || (groups[0].unredeemedQty && groups[0].unredeemedQty > 1);
    var diff = nextObj.threshold - nextObj.sub_total;
    var headlineText = withAmount(pickText(root, 'textRemainingSingular', 'textRemainingPlural', usePlural), diff);

    var previewsHtml = groups
      .map(function (g) { return renderProductPreview(findProduct(products, g.productItems[0])); })
      .join('');

    showFreeProductArea(
      '<div class="cart-drawer__free-products__headline cart-drawer__free-products__headline--progress">' +
        headlineText +
      '</div>' +
      '<div class="cart-drawer__free-products__previews">' + previewsHtml + '</div>' +
      (extraHtml || ''),
      'cart-drawer__free-products--progress'
    );
  }

  function renderReachedState(group, products, totalUnredeemedCount, extraHtml) {
    var root = getRoot();
    if (!root) return;

    var usePlural = totalUnredeemedCount > 1 || (group.unredeemedQty && group.unredeemedQty > 1);
    var headlineText = pickText(root, 'textReachedSingular', 'textReachedPlural', usePlural);
    var buttonLabel = root.dataset.textChooseButton;
    var orLabel = root.dataset.textOr;
    var shopRoot = (Shopify.routes && Shopify.routes.root) || '/';

    var alternativesHtml = group.productItems
      .map(function (handle, index) {
        var product = findProduct(products, handle);
        if (!product) return '';
        var productUrl = shopRoot + 'products/' + product.handle;
        var html =
          '<div class="cart-drawer__free-products__alternative">' +
            renderProductPreview(product) +
            '<button type="button" class="cart-drawer__free-products__btn button--primary"' +
              ' data-atc-modal-trigger data-product-url="' + escapeHtml(productUrl) + '" data-gift="true">' +
              '<span>' + escapeHtml(buttonLabel) + '</span>' +
              '<span class="loading__spinner hidden">' +
                '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
                  '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
                '</svg>' +
              '</span>' +
            '</button>' +
          '</div>';
        if (index < group.productItems.length - 1 && group.productItems.length > 1) {
          html += '<div class="cart-drawer__free-products__or" aria-hidden="true">' + escapeHtml(orLabel) + '</div>';
        }
        return html;
      })
      .join('');

    showFreeProductArea(
      '<div class="cart-drawer__free-products__headline cart-drawer__free-products__headline--reached">' +
        escapeHtml(headlineText) +
      '</div>' +
      '<div class="cart-drawer__free-products__alternatives">' + alternativesHtml + '</div>' +
      (extraHtml || ''),
      'cart-drawer__free-products--reached'
    );
  }

  /* ─── Auto-Remove ───────────────────────────────────────────── */

  /* Marker → Line-Item via data-line-item-key → click() auf cart-remove-button.
     Dawn's CartRemoveButton ruft cartItems.updateQuantity(line, 0) → fetch + Section-
     Rerender + publish(cartUpdate). Datora-Bridge → neuer co2.cart.initialized → nächster
     Cycle hier (via pending im trailing-edge wrapper). */
  function autoRemoveInvalidGift() {
    var marker = document.querySelector('[data-gift-remove-key]');
    if (!marker) return false;
    var lineEl = document.querySelector(
      '.cart-drawer__line-item[data-line-item-key="' + marker.dataset.giftRemoveKey + '"]'
    );
    if (!lineEl) return false;
    var removeBtn = lineEl.querySelector('cart-remove-button');
    if (!removeBtn) return false;
    removeBtn.click();
    return true;
  }

  /* ─── Main Cycle ────────────────────────────────────────────── */

  async function updateFreeProductUI() {
    var unredeemed = filterRenderableGroups(await co2.unredeemedFreeProducts());
    var nextRaw = await co2.nextFreeProducts();
    var nextGroups = filterRenderableGroups(nextRaw && nextRaw.items);
    var soldoutGroups = await getSoldoutGroups();
    var soldoutHtml = renderSoldoutMessages(soldoutGroups);
    /* Vor dem Hide-Check: leert die Region auch, wenn keine Meldung mehr ansteht */
    announceSoldout(soldoutGroups);

    if (unredeemed.length === 0 && nextGroups.length === 0 && soldoutHtml === '') {
      hideFreeProductArea();
      return;
    }

    var products = (await co2.freeProductData()) || [];

    /* Soldout-Meldungen sind additiv — Gruppen mit ausverkauften Gifts tauchen in
       unredeemed/next nicht auf, beides kann also gleichzeitig anstehen. */
    if (unredeemed.length > 0) {
      renderReachedState(unredeemed[0], products, unredeemed.length, soldoutHtml);
    } else if (nextGroups.length > 0) {
      var root = getRoot();
      if (root && root.dataset.suppressProgress === 'true') {
        /* CFSN-651: nur die Fortschrittsanzeige entfaellt (die kombinierte Bar zeigt sie),
           die additive Soldout-Meldung bleibt — sonst verschwaende sie samt Live-Region. */
        if (soldoutHtml) {
          showFreeProductArea(soldoutHtml, 'cart-drawer__free-products--soldout');
        } else {
          hideFreeProductArea();
        }
      } else {
        renderProgressState(nextRaw, products, soldoutHtml);
      }
    } else {
      showFreeProductArea(soldoutHtml, 'cart-drawer__free-products--soldout');
    }
  }

  async function runCycle() {
    if (autoRemoveInvalidGift()) {
      hideFreeProductArea();
      return;
    }
    await updateFreeProductUI();
  }

  async function triggerCycle() {
    if (typeof co2 === 'undefined') return;
    if (isHandling) {
      pending = true;
      return;
    }
    isHandling = true;
    try {
      do {
        pending = false;
        await runCycle();
      } while (pending);
    } finally {
      isHandling = false;
    }
  }

  /* Zwei Trigger:
     - co2.cart.initialized: co2 hat frische Daten
     - PUB_SUB_EVENTS.cartRerendered: cart-drawer-items / drawer-inner wurde neu in den
       DOM geschrieben (cart.js.onCartUpdate replaceWith, cart-drawer.renderContents).
       Bei externen cartUpdate-Sources (z. B. datora.refreshCartAndPrices) feuert co2
       u. U. vor dem replaceWith — dann wäre unser Render gewipt. Der zweite Trigger
       fängt das auf, der trailing-edge wrapper de-dupt parallele Aufrufe. */
  window.addEventListener('co2.cart.initialized', triggerCycle);
  subscribe(PUB_SUB_EVENTS.cartRerendered, triggerCycle);
})();
